export default __webpack_public_path__ + "static/automate-do-2-dark-de7aebd85da435d48f0ac977ee9c015a.png";